import { Component, OnInit, Input } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-asignaciones-tecnico',
  templateUrl: './asignaciones-tecnico.component.html',
  styleUrls: ['./asignaciones-tecnico.component.css']
})
export class AsignacionesTecnicoComponent implements OnInit {

  constructor(private service: UserService, private toast: ToastrService
    ) { }

  @Input()
  tecnico_especifico;

  asignaciones = [];
  ngOnInit() {
    this.service.getAsignaciones(this.tecnico_especifico).subscribe(d=>{
      this.asignaciones = d.asignaciones;
    }, er => { this.toast.error("ERROR")});
  }

}
